import React from 'react';
import { Card, Input } from '@avila-tek/ui/src';
import { Product, Variant } from '../../../models';
import FormHeader from '../../shared/Forms/FormHeader';

interface UpdateVariantFormContentProps {
  variant?: Variant;
  product?: Product;
  formState: Partial<Variant>;
  setFormState: React.Dispatch<React.SetStateAction<Partial<Variant>>>;
}

function UpdateVariantFormContent({
  variant,
  formState,
  setFormState,
  product,
}: UpdateVariantFormContentProps) {
  const { price, sku, compareAtPrice, option, isOnline } = formState;
  const { option1, option2, option3 } = option;
  const [isOnlineState, setIsOnlineState] = React.useState<boolean>(isOnline);

  const handleOptionInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormState({
      ...formState,
      option: {
        ...option,
        [name]: value,
      },
    });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  React.useEffect(() => {
    setFormState({
      ...formState,
      isOnline: isOnlineState,
    });
  }, [isOnlineState]);

  return (
    <Card>
      <FormHeader
        title={variant?.title}
        href={`/app/products/${product._id}?tab=variants`}
        backBtnText="Productos"
      />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-4">
          <div className="w-full">
            <Input
              name="sku"
              value={sku}
              label="SKU"
              type="text"
              placeholder="Ingrese un título"
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className=" flex md:flex-row flex-col gap-4">
          <div className="w-full">
            <Input
              name="price"
              value={price}
              label="Precio (pagado por beneficiario)"
              type="number"
              placeholder="Ingrese un precio"
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="w-full">
            <Input
              name="compareAtPrice"
              value={compareAtPrice}
              label="Precio comparativo"
              type="number"
              placeholder="Ingrese un precio comparativo"
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="w-full">
            <Input
              name="agreedPrice"
              label="Precio (acordado con aliado)"
              type="number"
              step="0.01"
              value={formState.agreedPrice}
              placeholder="Ingrese un precio acordado"
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className=" flex md:flex-row flex-col gap-4">
          {product?.options.length > 0 ? (
            <div className="w-full">
              <Input
                name="option1"
                value={option1}
                label={product?.options[0].name}
                type="text"
                onChange={handleOptionInputChange}
                required
              />
            </div>
          ) : null}
          {product?.options.length > 1 ? (
            <div className="w-full">
              <Input
                name="option2"
                value={option2}
                label={product?.options[1].name}
                type="text"
                onChange={handleOptionInputChange}
                required
              />
            </div>
          ) : null}
          {product?.options.length > 2 ? (
            <div className="w-full">
              <Input
                name="option3"
                value={option3}
                label={product?.options[2].name}
                type="text"
                onChange={handleOptionInputChange}
                required
              />
            </div>
          ) : null}
        </div>
        <div className="px-2 py-1 w-full space-x-2">
          <span>Compra online</span>
          <input
            type="checkbox"
            name="isOnline"
            checked={isOnlineState}
            onChange={() => setIsOnlineState(!isOnlineState)}
            className="w-4 h-4 cursor-pointer bg-white rounded border-purple-200 focus:ring-purple-300 focus:ring-2"
          />
        </div>
      </Card.Body>
    </Card>
  );
}

export default UpdateVariantFormContent;
